import { render, staticRenderFns } from "./YoungsDoubleSlitProViz.vue?vue&type=template&id=56ea34da&scoped=true"
import script from "./YoungsDoubleSlitProViz.vue?vue&type=script&lang=js"
export * from "./YoungsDoubleSlitProViz.vue?vue&type=script&lang=js"
import style0 from "./YoungsDoubleSlitProViz.vue?vue&type=style&index=0&id=56ea34da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea34da",
  null
  
)

export default component.exports